import instance from "../interceptors/AxiosInterceptor";

const BASE_URL = "/api/debtors";
const debtorService = {

    getDebtorsByUser: async () => {
        try {
            const response = await instance.get(`${BASE_URL}/all`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    addDebtor: async (debtor) => {
        try {
            const response = await instance.post(`${BASE_URL}/add`, debtor, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateDebtor: async (debtorId, debtor) => {
        try {
            const response = await instance.put(`${BASE_URL}/update/${debtorId}`, debtor, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    deleteDebtor: async (debtorId) => {
        try {
            const response = await instance.delete(`${BASE_URL}/delete/${debtorId}`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

}

export default debtorService;